import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=253af445&scoped=true"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"
import style0 from "./OfferList.vue?vue&type=style&index=0&id=253af445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253af445",
  null
  
)

export default component.exports